module.exports = __webpack_public_path__ + "img/thumbnail_KingPenguin_m_xanthic.ff3fec04.png";